"use client"

import { BluredOverlay } from "@/app/components/blured-overlay"
import { useIsSticky } from "@/app/hooks/use-sticky"
import { useBannerState } from "@/app/layout/banner/banner"
import { CollectionSearch } from "@/app/nft/search/result/view/collection-search"
import { NftSearchResult } from "@/app/nft/search/result/view/nft-search-result"
import type { ViewType } from "@/app/nft/search/result/view/view-selector/types"
import { useViewSelector } from "@/app/nft/search/result/view/view-selector/use-view-selector"
import { ViewSelector } from "@/app/nft/search/result/view/view-selector/view-selector"
import { NftSortPicker } from "@/app/nft/search/sort"
import { cn } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { CollectionSidebarTrigger } from "../../sidebar/trigger"
import { ClearFilters } from "./clear-filters"

interface Props {
  initialViewType: ViewType
}

export const CollectionItemsViewReatom = reatomComponent(
  ({ initialViewType }: Props) => {
    const { viewType, setViewType } = useViewSelector(initialViewType)
    const { isSticky, ref } = useIsSticky()
    const { isBannerClosed } = useBannerState()

    return (
      <div
        className="@container flex h-full flex-1 flex-col px-4 md:px-0"
        data-testid="collection-items-view"
      >
        <BluredOverlay
          ref={ref}
          className={cn(
            "flex flex-wrap @3xl:flex-nowrap items-center justify-between gap-3 pb-2 transition-all duration-200 md:sticky md:z-40 md:gap-4",
            isSticky && "pb-4",
            isBannerClosed
              ? "md:top-[calc(theme('spacing.header-height')+theme('spacing.collection-navigation-height'))]"
              : "md:top-[calc(theme('spacing.header-with-status-height')+theme('spacing.collection-navigation-height'))]",
          )}
        >
          <div className="flex items-center gap-[10px]">
            <CollectionSidebarTrigger />
            <ClearFilters />
          </div>
          <CollectionSearch />
          <div className="flex items-center gap-[10px]">
            <NftSortPicker />
            <ViewSelector onChange={setViewType} value={viewType} />
          </div>
        </BluredOverlay>
        <NftSearchResult viewType={viewType} />
      </div>
    )
  },
)
